export default __webpack_public_path__ + "static/media/find_composed.a04785ed.png";